import Controller from "@ember/controller"
import { inject as service } from "@ember/service"
import hasMany from "../../helpers/has-many"

export default class IndexController extends Controller {
  @service("ember-store")
  store

  @hasMany("model", "kb-entry", "children")
  children
}
